import type { ComponentPropsWithoutRef } from "react";
import { LottieLoading } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { fnNames, parseShowTokenWhyMoveTldr } from "@/src/utils";

type CodeProps = ComponentPropsWithoutRef<"span"> & {
  children?: React.ReactNode;
};

export const Bullet = ({
  options,
  itemClassName,
}: {
  options: string[];
  itemClassName?: string;
}) => (
  <ol className="list-decimal list-outside ml-5 [&>li::marker]:text-content_brand_primary flex flex-col gap-2">
    {options?.map((option: string) => (
      <li
        className={cn("body_medium_m text-content_primary", itemClassName)}
        key={option}
      >
        {option}
      </li>
    ))}
  </ol>
);

const Code = ({ children }: CodeProps) => {
  const childrenStr = children as string;
  const title = "TL;DR";

  // 判断是否包含函数名
  const isFunction = fnNames.some((fnName) => childrenStr?.includes(fnName));

  // 只有当包含函数名时才执行解析
  const result = isFunction ? parseShowTokenWhyMoveTldr(childrenStr) : null;

  const { summary, options = [] } = result || {};
  return isFunction ? (
    result ? (
      <div className="flex flex-col gap-3 mt-5">
        <div className="headline_regular_s text-content_primary">{title}</div>
        <div className="body_output text-content_primary">{summary}</div>
        <Bullet options={options} />
      </div>
    ) : (
      <div className="flex justify-center items-center">
        <LottieLoading style={{ width: 40, height: 40 }} />
      </div>
    )
  ) : (
    <>{children}</>
  );
};

export default Code;
